import { confirmation, notify } from '@/components';
import { useRemoveArticleMutation } from '@/redux/articles';

const useDelete = (props?: ActionProps) => {
  const { onSuccess } = props ?? {};
  const [remove] = useRemoveArticleMutation();

  return async (id: string) => {
    confirmation.delete({ key: 'articles.entity' }, () => {
      remove({ id })
        .unwrap()
        .then(() => {
          notify.success.t('articles.details.deleted');
        })
        .then(() => onSuccess && onSuccess());
    });
  };
};

interface ActionProps {
  onSuccess?: () => any;
}

export function useDeleteArticleAction(props?: ActionProps) {
  const deleteAction = useDelete(props);

  return {
    deleteAction,
  };
}
